import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  width: 100%;
  text-align: center;
  position: absolute;
  top: 40%; /* posiciona na metade da tela */
  margin-top: -25px; /* e retrocede metade da altura */
  h3 {
    font-weight: 1000;
  }

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    background-color: var(--red);
    border: 0;
    padding: 0 2rem;
    border-radius: 2rem;
    height: 3rem;
    transition: filter 0.2s;
    margin-top: 20px;
    &:hover {
      filter: brightness(0.9);
    }
    .back{
        font-size: 17px;
        margin-right: 10px;
    }
    p {
      font-weight: 500;
    }
  }
  justify-content: center;
  text-align: center;
`;

export const DivCenter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`;
